import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Checkboxes from './Checkboxes';
import ClientProvider from './client';
export default createDemo(import.meta.url, Checkboxes, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/checkboxes/demos/checkboxes/Checkboxes.tsx",
    "fileName": "Checkboxes.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Checkbox from '@mui/material/Checkbox';\n\nconst label = { slotProps: { input: { 'aria-label': 'Checkbox demo' } } };\n\nexport default function Checkboxes() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Checkbox {...label} defaultChecked />\n      <Checkbox {...label} />\n      <Checkbox {...label} disabled />\n      <Checkbox {...label} disabled checked />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 14,
        "focusedLines": 4,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Checkbox from '@mui/material/Checkbox';\n\nconst label = { slotProps: { input: { 'aria-label': 'Checkbox demo' } } };\n\nexport default function Checkboxes() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Checkbox {...label} defaultChecked />\n      <Checkbox {...label} />\n      <Checkbox {...label} disabled />\n      <Checkbox {...label} disabled checked />\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultChecked"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disabled"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disabled"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "checked"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 14,
    "focusedLines": 4,
    "collapsible": true,
    "externals": [
      "@mui/material/Checkbox"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
